export default __webpack_public_path__ + "static/media/bb-3times.01935c9a.svg";